import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthService } from '@app/@core-auth/services';
import { ChangePassword, ChangePasswordValidationMessages, LoginValidationMessages } from '@app/auth/models';
import { LoginFormService } from '@app/auth/services';
import { Observable } from 'rxjs';
import { LanguageSelectComponent } from '@app/@core-ui/';
import { ChangePasswordPageService } from '@app/auth/services/change-password-page.service';

@Component({
    selector: 'ngx-change-password-page',
    templateUrl: './change-password-page.component.html',
    styleUrls: ['./change-password-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ChangePasswordPageService],
    standalone: false
})
export class ChangePasswordPageComponent implements OnInit, OnDestroy {
  loading$: Observable<boolean>;
  form: UntypedFormGroup;
  validationMessages: ChangePasswordValidationMessages;

  email: string;
  token: string;

  public constructor(private changePasswordService: ChangePasswordPageService, private authService: AuthService, private router: Router, private route: ActivatedRoute) {
    this.loading$ = this.changePasswordService.loading$;
    this.form = this.changePasswordService.form;
    this.validationMessages = this.changePasswordService.validationMessages;
  }
  
  ngOnInit(): void {
    if (this.authService.getIsLoggedIn()) {
      this.router.navigate(['']);
    }

    this.route.params.subscribe(params => {
      this.email = params['email'];
      this.token = params['token'];
    });
  }

  save(pswd: ChangePassword) {
      this.changePasswordService.save(this.email, this.token, pswd.password);
  }

  ngOnDestroy() {}
}
